<script>
import snDropdownsMixin from './snDropdownsMixin.vue'

export default {
  name: 'SnSelect',
  mixins: [snDropdownsMixin],
  data () {
    return {
      vuetifyComponent: 'v-select'
    }
  }
}
</script>
